import * as React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink/index";
import { Callout } from "../../../../../../../packages/design-system-components/src/index";
export const EnableExtendedTagSetsCallout = () => {
    return (<Callout type={"information"} title={`Extended Tag Sets should be enabled to use this feature`}>
            Contact <ExternalLink href={"https://octopus.com/support"}>support</ExternalLink> to enable this feature.
        </Callout>);
};
